document.addEventListener('DOMContentLoaded', function() {
  // Existing Mobile Navigation Functionality (Intact)
  const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavClose = document.querySelector('.mobile-nav-close');
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-links a');

  if (mobileNavToggle && mobileNav && mobileNavClose) {
    mobileNavToggle.addEventListener('click', function() {
      mobileNav.classList.add('open');
    });

    mobileNavClose.addEventListener('click', function() {
      mobileNav.classList.remove('open');
    });

    mobileNavLinks.forEach(link => {
      if (link.href === window.location.href) {
        link.classList.add('active');
      }
    });
  }

  // Desktop Navigation Functionality (Modified for scroll behavior)
  const navBar = document.querySelector('.nav-bar');
  const navCenterImage = document.querySelector('.nav-center-image'); // 1. Select the center image
  let lastScrollTop = 0;

  if (navBar && navCenterImage) { // 2. Check that the image element exists
      window.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop < 10) {
            // Always show nav at top of page
            navBar.style.transform = 'translateY(0)';
            // The image's visibility class is not removed here,
            // so it stays visible if you scroll back to the very top.
          } else if (scrollTop > lastScrollTop) {
            // Scrolling down
            navBar.style.transform = 'translateY(-100%)';
            navCenterImage.classList.remove('image-visible'); // 3. Hide image when nav slides away
          } else {
            // Scrolling up
            navBar.style.transform = 'translateY(0)';
            navCenterImage.classList.add('image-visible'); // 4. Show image when nav slides back
          }

        lastScrollTop = scrollTop;
      });
  }

  // Existing Desktop Navigation Link Highlighting (Intact)
  const desktopNavLinks = document.querySelectorAll('.webpages a');

  desktopNavLinks.forEach(link => {
    if (link.href === window.location.href) {
      link.classList.add('active');
    }
  });

  // Existing Testimonials Slider Logic (Intact)
  const slides = document.querySelectorAll('.testimonials-slide');
  const prevButton = document.querySelector('.testimonials-prev');
  const nextButton = document.querySelector('.testimonials-next');
  const clientHeader = document.querySelector('.testimonials-client');

  let currentIndex = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      if (i === index) {
        slide.style.transform = 'translateX(0)';
        slide.style.opacity = '1';
        slide.style.position = 'relative';
        slide.style.zIndex = '1';
      } else {
        slide.style.transform = 'translateX(100%)';
        slide.style.opacity = '0';
        slide.style.position = 'absolute';
        slide.style.zIndex = '0';
      }
      slide.setAttribute('aria-hidden', i !== index);
    });

    // Update client name
    clientHeader.textContent = slides[index].dataset.client;
  }

  nextButton.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  });

  prevButton.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  });

  // Initialize
  showSlide(currentIndex);

  // --- Swipe Support for Mobile Devices (Improved) ---
  let startX = 0;
  let isSwiping = false;

  const sliderContainer = document.querySelector('.testimonials-slider');

  sliderContainer.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isSwiping = true;
  }, { passive: true });

  sliderContainer.addEventListener('touchmove', (e) => {
    if (!isSwiping) return;

    const currentX = e.touches[0].clientX;
    const diff = startX - currentX;

    if (Math.abs(diff) > 10) {
      e.preventDefault(); // Prevent horizontal scroll when swiping
    }
  }, { passive: false });

  sliderContainer.addEventListener('touchend', (e) => {
    if (!isSwiping) return;
    isSwiping = false;

    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;
    const swipeThreshold = 50;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swiped left → next
        nextButton.click();
      } else {
        // Swiped right → previous
        prevButton.click();
      }
    }
  });
});